<mat-stepper orientation="horizontal" [linear]="false" #stepper id="stepper">

  <mat-step [stepControl]="packagingsFormGroup" completed="false">
    <ng-template matStepLabel>
      {{ 'dataEvaluation.performEvaluations.stepLabels.packagingSelection' | transloco }}
    </ng-template>

    <form [formGroup]="packagingsFormGroup" class="form-class">
      <mat-tab-group class="tab-group">
        <mat-tab label="{{ 'dataEvaluation.performEvaluations.tabLabels.packagingSystems' | transloco }}">
          <div>
            {{ 'dataEvaluation.performEvaluations.stepDescriptions.packagingSystemsSelection' | transloco }}
            <button (click)="selectAllPackagingSystems()" mat-stroked-button type="button" color="accent" class="select-button">
              {{ 'dataEvaluation.performEvaluations.buttons.selectAll' | transloco }}
            </button>
            <button (click)="selectNoPackagingSystems()" mat-stroked-button type="button" color="accent" class="select-button">
              {{ 'dataEvaluation.performEvaluations.buttons.selectNone' | transloco }}
            </button>
          </div>
          <div class="scrolling-wrapper">
            <app-packaging-systems-overview #packagingSystemsTable [dataSource]="packagingSystemsDataSource" [allTags]="allTags"
              [displayedColumns]="displayedColumnsPackagingSystems" (packagingPartsSelected)="packagingSystemsSelected($event)">
            </app-packaging-systems-overview>
          </div>
        </mat-tab>

        <mat-tab label="{{ 'dataEvaluation.performEvaluations.tabLabels.packagingUnits' | transloco }}">
          <div>
            {{ 'dataEvaluation.performEvaluations.stepDescriptions.packagingUnitsSelection' | transloco }}
        <button (click)="selectAllPackagingUnits()" mat-stroked-button type="button" color="primary" class="select-button">
              {{ 'dataEvaluation.performEvaluations.buttons.selectAll' | transloco }}
            </button>
            <button (click)="selectNoPackagingUnits()" mat-stroked-button type="button" color="primary" class="select-button">
              {{ 'dataEvaluation.performEvaluations.buttons.selectNone' | transloco }}
            </button>
          </div>
          <div class="scrolling-wrapper">
            <app-packaging-units-overview #packagingUnitsTable [dataSource]="packagingUnitsDataSource" [allTags]="allTags"
              [displayedColumns]="displayedColumnsPackagingUnits" (packagingPartsSelected)="packagingUnitsSelected($event)">
            </app-packaging-units-overview>
          </div>
        </mat-tab>
      </mat-tab-group>

        <div>
          <button mat-raised-button matStepperNext>
            {{ 'dataEvaluation.performEvaluations.buttons.next' | transloco }}
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </form>


  </mat-step>

  <mat-step [stepControl]="countriesFormGroup" completed="false">
    <form [formGroup]="countriesFormGroup" class="form-class">
      <ng-template matStepLabel>
        {{ 'dataEvaluation.performEvaluations.stepLabels.countriesSelection' | transloco }}
      </ng-template>
      <div>
        {{ 'dataEvaluation.performEvaluations.stepDescriptions.countriesSelection' | transloco }}
        <button (click)="selectAllCountries()" mat-stroked-button type="button" color="primary" class="select-button">
          {{ 'dataEvaluation.performEvaluations.buttons.selectAll' | transloco }}
        </button>
        <button (click)="selectNoCountries()" mat-stroked-button type="button" color="primary" class="select-button">
          {{ 'dataEvaluation.performEvaluations.buttons.selectNone' | transloco }}
        </button>
      </div>
      <div class="scrolling-wrapper">
        <app-buying-from-shop *ngIf="allCountries.length <= 0" [buyType]="buyType.AllCountries">
        </app-buying-from-shop>
        <mat-selection-list *ngIf="allCountries.length > 0" #countriesSelectionList formControlName="countriesList" class="narrow-list">
          <mat-list-option *ngFor="let country of allCountries" [value]="country" [disabled]="!this.isCountryAuthorized(country.code)"
            [matTooltip]="this.getTooltipName(country.name, country.code)" matTooltipPosition = "right">
            <mat-icon *ngIf="!this.isCountryAuthorized(country.code)">lock</mat-icon>
            {{ country.name }}
          </mat-list-option>
        </mat-selection-list>
      </div>
      <div>
        <button mat-raised-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon>
          {{ 'dataEvaluation.performEvaluations.buttons.back' | transloco }}
        </button>
        <button mat-raised-button matStepperNext>
          {{ 'dataEvaluation.performEvaluations.buttons.next' | transloco }}
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="datesFormGroup" completed="false">
    <form [formGroup]="datesFormGroup" class="form-class">
      <ng-template matStepLabel>{{ 'dataEvaluation.performEvaluations.stepLabels.datesSelection' | transloco }}
      </ng-template>
      <div>
        {{ 'dataEvaluation.performEvaluations.stepDescriptions.datesSelection' | transloco }}
      </div>
      <mat-form-field class="date-field">
        <mat-label>{{ 'dataEvaluation.performEvaluations.datePicker.startDate' | transloco }}</mat-label>
        <input matInput autocomplete="off" [matDatepicker]="dpStart" [formControl]="startDateControl">
        <mat-hint>{{ 'dataEvaluation.performEvaluations.datePicker.hint' | transloco }}</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
        <mat-datepicker #dpStart startView="multi-year"
          (monthSelected)="setMonthAndYear($event, dpStart, datesFormGroup.controls.startDate)"
          panelClass="example-month-picker">
        </mat-datepicker>
        <mat-error *ngIf="datesFormGroup.controls.startDate.errors">
          <span *ngIf="datesFormGroup.controls.startDate.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
          <span *ngIf="datesFormGroup.controls.startDate.errors.endBeforeStart">
            {{ 'dataEvaluation.performEvaluations.errors.endBeforeStart' | transloco }}
          </span>
          <span *ngIf="datesFormGroup.controls.startDate.errors.outOfRange">
            {{ 'dataEvaluation.performEvaluations.errors.outOfRange' | transloco: {range: maxDatesRangeInMonths} }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="date-field">
        <mat-label>{{ 'dataEvaluation.performEvaluations.datePicker.endDate' | transloco }}</mat-label>
        <input matInput autocomplete="off" [matDatepicker]="dpEnd" [formControl]="endDateControl">
        <mat-hint>{{ 'dataEvaluation.performEvaluations.datePicker.hint' | transloco }}</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
        <mat-datepicker #dpEnd startView="multi-year"
          (monthSelected)="setMonthAndYear($event, dpEnd, datesFormGroup.controls.endDate)"
          panelClass="example-month-picker">
        </mat-datepicker>
        <mat-error *ngIf="datesFormGroup.controls.endDate.errors">
          <span *ngIf="datesFormGroup.controls.startDate.errors?.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
          <span *ngIf="datesFormGroup.controls.endDate.errors.endBeforeStart">
            {{ 'dataEvaluation.performEvaluations.errors.endBeforeStart' | transloco }}
          </span>
          <span *ngIf="datesFormGroup.controls.endDate.errors.outOfRange">
            {{ 'dataEvaluation.performEvaluations.errors.outOfRange' | transloco: {range: maxDatesRangeInMonths} }}
          </span>
        </mat-error>
      </mat-form-field>
      <div>
        <button mat-raised-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon>
          {{ 'dataEvaluation.performEvaluations.buttons.back' | transloco }}
        </button>
        <button mat-raised-button matStepperNext>
          {{ 'dataEvaluation.performEvaluations.buttons.next' | transloco }}
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="evalTypesFormGroup" completed="false">
    <form [formGroup]="evalTypesFormGroup" class="form-class">
      <ng-template matStepLabel>{{ 'dataEvaluation.performEvaluations.stepLabels.evalTypesSelection' | transloco }}
      </ng-template>
      <mat-selection-list #evaluationsSelectionList formControlName="evaluationsList" class="narrow-list">
        <mat-list-option *ngFor="let evaluationType of evaluationTypes" [value]="evaluationType" [disabled]="isEvaluationDeactivated(evaluationType.key)"
          [matTooltip]="isEvaluationDeactivated(evaluationType.key)? ('warnings.NoPremiumUserAndEnvironmentalEffects' | transloco) : ''"
          matTooltipPosition = "right">
          {{ evaluationType.value }}
        </mat-list-option>
      </mat-selection-list>
      <div>
        <button mat-raised-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon>
          {{ 'dataEvaluation.performEvaluations.buttons.back' | transloco }}
        </button>
        <button mat-raised-button matStepperNext>
          {{ 'dataEvaluation.performEvaluations.buttons.next' | transloco }}
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step completed="false">
    <ng-template matStepLabel>{{ 'dataEvaluation.performEvaluations.stepLabels.performEvaluation' | transloco }}
    </ng-template>
    <div>

      <p>{{ 'dataEvaluation.performEvaluations.stepDescriptions.performEvaluation' | transloco }}</p>
      <br>
      <p [ngClass]="{'red': packagingSystemsCount + packagingUnitsCount === 0}">
        {{ 'dataEvaluation.performEvaluations.messages.packagingSystemsCount' | transloco: {count: packagingSystemsCount } }}
      </p>
      <p [ngClass]="{'red': packagingSystemsCount + packagingUnitsCount === 0}">
        {{ 'dataEvaluation.performEvaluations.messages.packagingUnitsCount' | transloco: {count: packagingUnitsCount } }}
      </p>
      <p [ngClass]="{'red': countriesCount === 0}">
        {{ 'dataEvaluation.performEvaluations.messages.countriesCount' | transloco: {count: countriesCount} }}
      </p>
      <p [ngClass]="{'red': !datesFormGroup.controls.startDate.value || !datesFormGroup.controls.endDate.value }">
        {{ 'dataEvaluation.performEvaluations.messages.dateRange' | transloco: {from: startDate, to: endDate} }}
      </p>
      <p [ngClass]="{'red': evaluationsCount === 0}">
        {{ 'dataEvaluation.performEvaluations.messages.evalTypes' | transloco: {types: getSelectedEvalTypeNames()} }}
      </p>
    </div>
    <div>
      <mat-form-field class="form-field-medium">
        <mat-label>{{ 'dataEvaluation.performEvaluations.evalName' | transloco }}</mat-label>
        <input matInput autocomplete="off" [formControl]="evalNameFormControl">
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" (click)="performEvaluations(stepper)">
      {{ 'dataEvaluation.performEvaluations.buttons.evaluate' | transloco }}
    </button>
    <button mat-raised-button color="warn" (click)="resetForm(stepper)">
      {{ 'dataEvaluation.performEvaluations.buttons.reset' | transloco }}
    </button>
    <div>
      <button mat-raised-button matStepperPrevious>
        <mat-icon>arrow_back</mat-icon>
        {{ 'dataEvaluation.performEvaluations.buttons.back' | transloco }}
      </button>
    </div>
  </mat-step>

  <mat-step completed="false">
    <ng-template matStepLabel>{{ 'dataEvaluation.performEvaluations.stepLabels.viewEvaluation' | transloco }}
    </ng-template>
    <div class="full-height" *ngIf="showEvaluations; else emptyTemplate">
      <mat-tab-group color="accent" [backgroundColor]="" class="full-height">
        <mat-tab label="{{ 'dataEvaluation.evaluationType.recLabel' | transloco }}"
          *ngIf="recEvaluation">
          <div class="tab-content" #recContent>
            <app-view-recyclability-aggregate-evaluation [recEvaluation]="recEvaluation" [isDarkTheme]="isDarkTheme"
              [isScrollingEnabled]="isRecScrollingEnabled" (scrollToTableEvent)="scrollToRecTable()">
            </app-view-recyclability-aggregate-evaluation>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'dataEvaluation.evaluationType.lcaLabel' | transloco }}" *ngIf="lcaEvaluation">
          <div class="full-height" class="tab-content">
            <app-view-lifecycle-aggregate-evaluation [lcaEvaluation]="lcaEvaluation" [isDarkTheme]="isDarkTheme">
            </app-view-lifecycle-aggregate-evaluation>
          </div>
        </mat-tab>
        <mat-tab bodyClass="mass-tab" label="{{ 'dataEvaluation.evaluationType.massLabel' | transloco }}"
          *ngIf="massEvaluation">
          <div class="tab-content" #massContent>
            <app-view-mass-aggregate-evaluation [massEvaluation]="massEvaluation" [isDarkTheme]="isDarkTheme"
              [isScrollingEnabled]="isMassScrollingEnabled" (scrollToTableEvent)="scrollToMassTable()">
            </app-view-mass-aggregate-evaluation>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <ng-template #emptyTemplate>
      <div id="placeholder-card">
        <span class="hint margin">{{ 'dataEvaluation.performEvaluations.messages.noEvaluationYet' | transloco }}</span>
      </div>
    </ng-template>
    <div>
      <button *ngIf="showEvaluations" mat-raised-button color="primary" (click)="startNewEvaluation(stepper)">
        {{ 'dataEvaluation.performEvaluations.buttons.newEvaluation' | transloco }}
      </button>
    </div>
  </mat-step>
</mat-stepper>
